import { Avatar } from "@mui/material"
import HtClass from "./HtClass";
import { useNavigate } from "react-router-dom";

export default function StudentCard({ student }) {
  const navigate = useNavigate();

  // Determine status color theme
  const statusType = student.status?.toLowerCase() || "unknown";
  const statusClass = statusType === "active" ? "status-active" : "status-stopped";

  return (
    <div
      className="student-card-premium"
      onClick={() => navigate(`/student/${student._id}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && navigate(`/student/${student._id}`)}
    >
      <Avatar
        src={`/images/${student.image}`}
        alt={student.name}
        sx={{ 
          width: 70, 
          height: 70,
          border: '3px solid #fff',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
        }}
      />
      <div className="student-card-name">{student.name}</div>
      
      <div className="flex flex-wrap justify-center gap-1 min-h-[20px]">
        {student.classes?.map((c) => (
          <HtClass
            key={c._id}
            htClass={c._id}
            link
          />
        ))}
      </div>

      <div className={`student-status-badge ${statusClass}`}>
        {student.status}
      </div>
    </div>
  );
}